import { computed } from 'vue';
import store from '@/store';
import { message } from '@/utils/js/initVariable';
import { ElMessageBox } from 'element-plus';
import { deleteAnnotation } from '@/api/UserWorkspaceDataApi';
import { deleteUserWorkspaceGeoJsonData } from '@/api/WorkspaceApi';

/**
 * 保存提交/删除标注/删除区域内元素
 * @param {Object} props - 组件 props
 * @param {Object} editTarget - reactive 编辑目标
 * @param {Function} emit - defineEmits
 * @param {Ref} loadProp - loading 属性名
 * @param {String} ifContinuousTrackingProp 
 * @param {String} ifContinuousStatisticsProp
 */
export function useSaveAndDelete(props, editTarget, emit, loadProp, ifContinuousTrackingProp, ifContinuousStatisticsProp) {
  const submitPort = computed(() => store.getters['polySubmitPort']);
  let featureChangeFn;

  const setFeatureChangeFn = (fn) => {
    featureChangeFn = fn;
  };

  const saveSubmit = () => {
    if (!submitPort.value) {
      message('请先在工作台选择底图后再保存', 2);
      return;
    }
    const layer = props.layer,
      geojson = layer.toGeoJSON();
    if (!geojson['properties']) geojson['properties'] = {};
    if (editTarget['fill']) geojson['properties']['fill'] = editTarget['fill'];
    if (editTarget['weight']) geojson['properties']['weight'] = editTarget['weight'];
    if (editTarget['dashArray']) geojson['properties']['dashArray'] = editTarget['dashArray'];

    const id = editTarget['annotationId'], name = editTarget['annotationName'], intention = editTarget['regionIntention'];
    if (!name) {
      message('请输入区域名称', 2);
      return;
    }
    const geojsonStr = JSON.stringify(geojson),
      featureCheckList = (editTarget['featureList'] || []).filter(e => {
        return e['isCheck'];
      });
    const data = {
      bizType: 3,
      bizId: props.workSpace && props.workSpace['id'],
      annotationId: id,
      annotationName: name,
      regionIntention: intention,
      geom: geojsonStr,
      regionFeatureList: featureCheckList,
      eventList: editTarget['eventList'],
      exposureCountList: editTarget['exposureCountList'] ? editTarget['exposureCountList'].map(e => {
        return e['exposureList']
      }).reduce((acc, curr) => [...acc, ...curr], []) : [],
      shootingLocationList: editTarget['shootingLocationList'],
      id: id,
      regionGeom: geojsonStr,
      regionName: name,
      regionDesc: intention,
      tags: featureCheckList,
      ifContinuousTracking: editTarget[ifContinuousTrackingProp] ? 1 : 0,
      ifContinuousStatistics: editTarget[ifContinuousStatisticsProp] ? 1 : 0,
    }
    submitPort.value && submitPort.value(data).then(res => {
      if (res.data.code === 1004) {
        if (res.data.data) {
          const returnData = res.data.data;
          props.target['annotationId'] = returnData['id'];
          editTarget['annotationId'] = returnData['id'];
          props.target['id'] = returnData['id'];
          editTarget['id'] = returnData['id'];
          // 持续跟踪
          editTarget[ifContinuousTrackingProp] = returnData[ifContinuousTrackingProp] === 1;
          props.target[ifContinuousTrackingProp] = returnData[ifContinuousTrackingProp] === 1;
          // 持续统计
          editTarget[ifContinuousStatisticsProp] = returnData[ifContinuousStatisticsProp] === 1;
          props.target[ifContinuousStatisticsProp] = returnData[ifContinuousStatisticsProp] === 1;
        }
        featureChangeFn?.();
        message(res.data.msg, 1);
      }
    }).catch(err => {
      console.log(err);
    });
  }

  const deleteFn = () => {
    ElMessageBox.confirm(
      `是否删除当前标注`,
      '提示',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true,
      }
    ).then(res => {
      if (!editTarget['annotationId']) {
        emit('layerDelete');
        return;
      }
      deleteAnnotation(editTarget['annotationId']).then(res => {
        if (res.data.code === 1004) {
          emit('layerDelete');
          message(res.data.msg, 1);
        }
      }).catch(err => {
        console.log(err);
      });
    }).catch(err => {
      console.log(err);
    });
  }

  const delPolyLayer = (btn) => {
    btn[loadProp.value] = true;
    ElMessageBox.confirm(
      `是否删除当前区域内元素`,
      '提示',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true,
      }
    ).then(res => {
      const checkList = props.workSpaceDataList.filter(e => e['check']),
        delDataIds = checkList.map(e => {
          return e['id'];
        }),
        geojson = props.layer.toGeoJSON(),
        delGeo = geojson['geometry'];
      deleteUserWorkspaceGeoJsonData({
        idList: delDataIds,
        geometry: JSON.stringify(delGeo),
      }).then(res => {
        if (res.data.code === 1004) {
          message(res.data.msg, 1);
          emit('delPolyLayerSucceedFn', res.data.data || []);
        }
        btn[loadProp.value] = false;
      }).catch(err => {
        btn[loadProp.value] = false;
        console.log(err);
      });
    }).catch(err => {
      btn[loadProp.value] = false;
      console.log(err);
    });
  }

  return { saveSubmit, deleteFn, delPolyLayer, setFeatureChangeFn };
}
